
import dust from "dustjs-linkedin";


(function(){dust.register("progress/slider",body_0);function body_0(chk,ctx){return chk.write("<section class=\"slider\" data-value=\"0\" data-maximum=\"").reference(ctx.get(["maximum"], false),ctx,"h").write("\"><div class=\"slider-content\"><div class=\"slider-filled\"></div><div class=\"slider-knob\"><div class=\"slider-knob-inner\"></div></div></div></section>");}return body_0;})();

export default 0;
